var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto",attrs:{"id":"container"}},[_c('Header'),_c('div',{staticClass:"text-center my-5",domProps:{"innerHTML":_vm._s(_vm.cancellationSuccessText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }